import { useState } from 'react'

export function useGeolocation() {
  const [location, setLocation] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const getLocation = () => {
    setLoading(true)
    setError(null)

    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser')
      setLoading(false)
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords
        // In a real app, we'd reverse geocode this to an address
        setLocation(`${latitude.toFixed(4)}, ${longitude.toFixed(4)}`)
        setLoading(false)
      },
      (err) => {
        setError('Unable to retrieve your location')
        setLoading(false)
      },
    )
  }

  return { location, loading, error, getLocation }
}
